import React, { useState } from "react";
import StepperControl from "../components/Stepper/StepperControl";
import Stepper from "../components/Stepper/Stepper";
import Property from "../components/Steps/Property";
import { UseContextProvider } from "../context/MainContext";
import Features from "../components/Steps/Features";
import Remarks from "../components/Steps/Remarks";
import Complete from "../components/Steps/Complete";
import ListingType from "../components/Steps/ListingType";
import { useStepperContext } from "../context/MainContext";

const ResidentialAdd = () => {
  const [currentStep, setCurrentStep] = useState(1); // Allows form to either move forward or backward in steps
  // propertyData is provided inside UseContextProvider below; we'll
  // render the interactive area inside that provider so children and
  // validation share the same context instance.
  // Defining steps to be displayed
  const steps = [
    "Listing Type",
    "Property",
    "Features",
    "Remarks/Info",
    // "Showing Information",
    // "Contract Info",
    "Upload Images",
  ];
  // displayStep will be defined within the interactive Inner component
  // so it can access `uploadedItems` and `modal` state.
  // We'll render the interactive portion inside the Stepper context provider
  // so validation reads the same `propertyData` instance that the Property
  // step updates.
  const Inner = () => {
    const { propertyData } = useStepperContext();
    const [modal, setModal] = useState(false);
    const [uploadedItems, setUploadedItems] = useState([]);

    const validateStep = (stepToValidate) => {
      if (stepToValidate === 2) {
        const pd = propertyData || {};
        const missing = [];

        // If vacant land selected -> require acreage and vacant_land_type
        if (pd["vacant_land"] === "Yes") {
          if (!pd["acreage"]) missing.push("Acreage");
          if (!pd["vacant_land_type"]) missing.push("Vacant land type");
          // disallow Commercial type for Residential listings
          if (
            pd["type"] === "Residential" &&
            pd["vacant_land_type"] === "Commercial"
          ) {
            missing.push("Invalid vacant land type for Residential listing");
          }
        } else {
          // Non-vacant: require core fields
          const req = [
            ["street_number", "Street Number"],
            ["street_name", "Street Name"],
            ["street_type", "Street Type"],
            ["city", "City"],
            ["zip", "Zip"],
            ["county", "County"],
            ["price", "Price"],
            ["beds_total", "Beds Total"],
            ["baths_full", "Baths"],
            ["acreage", "Acreage"],
            ["living_sqft", "Living SqFt"],
            ["living_areas", "Living Areas"],
            ["est_year_built", "Est Year Built"],
          ];
          req.forEach(([k, label]) => {
            if (!pd[k]) missing.push(label);
          });
        }

        return missing;
      }

      if (stepToValidate === 4) {
        const pd = propertyData || {};
        const missing = [];
        if (!pd["listing_start_date"]) missing.push("Listing Start Date");
        if (!pd["listing_expiration_date"])
          missing.push("Listing Expiration Date");
        return missing;
      }

      return [];
    };

    const handleClick = (direction) => {
      if (direction === "next") {
        const missing = validateStep(currentStep);
        if (missing && missing.length > 0) {
          window.alert(
            `Please complete the following required fields before continuing:\n- ${missing.join(
              "\n- "
            )}`
          );
          return;
        }
      }

      let newStep = currentStep;
      direction === "next" || direction === "confirm" ? newStep++ : newStep--;
      // check if steps are within bounds
      if (direction === "confirm") {
        setModal(true);
      }
      newStep > 0 && newStep <= steps.length && setCurrentStep(newStep);
    };

    const displayStep = (step) => {
      switch (step) {
        case 1:
          return <ListingType />;
        case 2:
          return <Property />;
        case 3:
          return <Features />;
        case 4:
          return <Remarks />;
        case 5:
          return (
            <Complete
              uploadedItems={uploadedItems}
              setUploadedItems={setUploadedItems}
              modal={modal}
              setModal={setModal}
            />
          );
        default:
          return <h1>ERROR.</h1>;
      }
    };

    return (
      <>
        {displayStep(currentStep)}

        {currentStep !== steps.length + 1 && (
          <StepperControl
            handleClick={handleClick}
            currentStep={currentStep}
            steps={steps}
            isNextDisabled={validateStep(currentStep).length > 0}
          />
        )}
      </>
    );
  };

  return (
    <div className="w-full rounded-10 border-2 border-black pb-2 my-36">
      <div className="  mt-5 ">
        <Stepper steps={steps} currentStep={currentStep} />
        <div className="my-10 p-10">
          {/* Div is placed here to allow user to paginate through steps quicker without having to scroll down */}
          <div className="">
            <UseContextProvider>
              <Inner />
            </UseContextProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResidentialAdd;
